export default {
    chooseManager: 'בחרי מנהלת',
    manager: 'מנהל',
    designer: 'מעצבת',
}
